module.exports = __webpack_public_path__ + "images/sns_campaign_lp/mainvisual-present-2-pc@2x_77a3a60e7b2d63f0d8697d051f3454fc.png";